module.exports = __webpack_public_path__ + "img/campfire.c096237b.png";